import { motion } from 'motion/react'
import { enterVariants } from '../../lib/motion'

const FACTS = [
  {
    title: 'Your Trello token',
    body: 'Stored in our database and used only to create cards on your behalf. Disconnecting deletes it.',
  },
  {
    title: 'Your notes',
    body: 'Sent to OpenAI to be parsed into tasks. We do not use them to train anything.',
  },
  {
    title: 'Your cards',
    body: 'Created in your own Trello account. We keep a record of what was created so you can see it in your history.',
  },
  {
    title: 'Your control',
    body: 'Disconnect Trello at any time from Settings. That removes the token and clears the cached team list.',
  },
]

export default function Privacy() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-28">
      <h2 className="max-w-2xl text-[1.875rem] font-semibold tracking-[-0.025em] text-white md:text-h2">
        What we do with your data
      </h2>
      <p className="mt-4 max-w-xl text-body text-white/50">
        Plainly, without the badges.
      </p>

      <motion.dl
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ staggerChildren: 0.06 }}
        className="mt-12 grid gap-x-10 gap-y-10 md:grid-cols-2"
      >
        {FACTS.map((fact) => (
          <motion.div key={fact.title} variants={enterVariants}>
            <dt className="text-h3 font-medium text-white">{fact.title}</dt>
            <dd className="mt-2 text-body text-white/50">{fact.body}</dd>
          </motion.div>
        ))}
      </motion.dl>
    </section>
  )
}
